export default ({ text, href, label }) => `
<a title="${text}" href="${href}" aria-label="${label}">${text}</a>
`;
